/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useEffect } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { getCoinsRequest, getCompaniesRequest} from "../../actions/logistic-indicators.action"
import { useDispatch, useSelector } from "react-redux"
import ProjectsSearchInput from "./ProjectsSearchInput"
import { Grid } from "@material-ui/core"
import MaterialSelect from "../../components/MaterialSelect"
import MaterialDateInput from "../../components/MaterialDateInput"

const Modes = [{
  value: '-1',
  label: 'Proyectos',
}, {
  value: '1',
  label: 'Dimensión 1',
}, {
  value: '2',
  label: 'Dimensión 2',
}, {
  value: '3',
  label: 'Dimensión 3',
}, {
  value: '4',
  label: 'Dimensión 4',
}, {
  value: '5',
  label: 'Dimensión 5',
}]

// const Periods = [{
//   value: '0',
//   label: 'Mensual'
// }, {
//   value: '1',
//   label: 'Semanal'
// }, {
//   value: '2',
//   label: 'Anual'
// }]


const InputsGroup = ({
  allowCompanyAll = true,
  allowEmptyProject = true,
  selectedCoin,
  setSelectedCoin,
  selectedCompany,
  setSelectedCompany,
  mode,
  setMode,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  period,
  setPeriod,
  selectedProject,
  setSelectedProject,
}) => {
  const logisticIndicators = useSelector((state) => state.logisticIndicators);
  const dispatch = useDispatch();

  useEffect(() => {
    if (logisticIndicators.coins.length || logisticIndicators.coinsLoading) {
      return;
    }
    dispatch(getCoinsRequest())
  }, [])

  useEffect(() => {
    if (logisticIndicators.companiesLoading) {
      return;
    }
    dispatch(getCompaniesRequest(startDate, endDate))
  }, [startDate, endDate])

  useEffect(() => {
    if (!logisticIndicators.companies.length || selectedCompany || allowCompanyAll) {
      return;
    }
    setSelectedCompany(logisticIndicators.companies[0].CodEmpresa)
  }, [logisticIndicators.companies, selectedCompany])


  return (
    <Grid container direction="row">
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Moneda"
          value={selectedCoin}
          onChange={(e) => setSelectedCoin(e.target.value)}
          width="4.5em"
        >
          {logisticIndicators.coins.map(c => (
            <option 
              key={c.CodMonedaInternacional} 
              value={c.CodMonedaInternacional}
            >
              {c.Descripcion}
            </option>
          ))}
        </MaterialSelect>
      </Grid>
      {setStartDate && <Grid item style={{marginRight: '1em'}}>
        <MaterialDateInput
          label="Del"
          value={startDate}
          onChange={setStartDate}
          width="7em"
        />
      </Grid>}
      {setEndDate && <Grid item style={{marginRight: '1em'}}>
        <MaterialDateInput
          label="Al"
          value={endDate}
          onChange={setEndDate}
          width="7em"
        />
      </Grid>}
      <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Empresa"
          value={selectedCompany}
          onChange={(e) => setSelectedCompany(e.target.value)}
          width="7em"
        >
          {allowCompanyAll && !!logisticIndicators?.companies?.length && <option value="">Todos</option>}
          {logisticIndicators.companies.map(c => (
            <option 
              key={c.CodEmpresa} 
              value={c.CodEmpresa}
            >
              {c.Descripcion}
            </option>
          ))}
        </MaterialSelect>
      </Grid>
      {/* <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Modo"
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          width="6em"
        >
          {Modes.map((p) => (<option key={p.value} value={p.value}>{p.label}</option>))}
        </MaterialSelect>
      </Grid> */}
      <Grid item style={{marginRight: '1em'}}>
        <ProjectsSearchInput 
          allowEmptySelection={allowEmptyProject}
          label={Modes.find(m => m.value === mode).label}
          selectedProject={selectedProject} 
          setSelectedProject={setSelectedProject} 
          width='15em'
        />
      </Grid>
      {/* <Grid item style={{marginRight: '1em'}}>
        <MaterialSelect
          label="Escala"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          width="5em"
        >
          {Periods.map((p) => (<option value={p.value}>{p.label}</option>))}
        </MaterialSelect>
      </Grid> */}
    </Grid>
  )
}

export default InputsGroup